var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMotorcycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45 35",
    enableBackground: "new 0 0 45 35",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3C3C3B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M7.8,29.3c-2.3,0-1.8,0-1.8,0s0.1-7.9,3.4-7.9s12.6,0,12.6,0s-4.8,2.8-0.6,7.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3C3C3B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M27.8,16.9h1c1.7,2.9,2.8,4.7,2.3,6.3c-0.4,1.4-4,6-5,6c-2.7,0-5.6,0-9.9,0"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#3C3C3B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 36,
    cy: 29.9,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3C3C3B",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M30.3,30.4c0-0.2,0-0.3,0-0.5 c0-3.2,2.6-5.7,5.7-5.7c1.7,0,3.2,0.7,4.3,1.9"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3C3C3B",
    cx: 21.9,
    cy: 4,
    r: 2.9
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#3C3C3B",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 17,
    y1: 17.9,
    x2: 19.7,
    y2: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#3C3C3B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 20.6,
    y1: 8.8,
    x2: 22.2,
    y2: 13.4
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#3C3C3B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 22.2,
    y1: 13.4,
    x2: 27.9,
    y2: 15.2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#3C3C3B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 16.6,
    y1: 18.4,
    x2: 24.6,
    y2: 18.3
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#3C3C3B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 24.6,
    y1: 18.3,
    x2: 26.6,
    y2: 25.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3B",
    d: "M31.7,16.7c-0.9,0-1.7-0.7-1.7-1.7s0.7-1.7,1.7-1.7"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#3C3C3B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 12,
    cy: 29.9,
    r: 3.6
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3B",
    d: "M14.2,17.2c0,1.1-1,2.9-2.3,2.9H5.7c-1.3-0.1-2.3-1.9-2.3-2.9l0,0c0-1.1,1-3.9,2.3-3.9h6.2 C13.2,13.3,14.2,16.1,14.2,17.2L14.2,17.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorcycle);
export default __webpack_public_path__ + "static/media/motorcycle.efbf26815108ca0239bf8dbaae697be2.svg";
export { ForwardRef as ReactComponent };